import React from "react";
import { SvgIcon, SvgIconProps, useTheme } from "@mui/material";

const FavouriteIcon: React.FC<SvgIconProps & { filled: boolean }> = React.memo(({ filled, ...props }) => {
    const theme = useTheme()
    const activeColor = theme.palette.primary.main

    return (
        <SvgIcon viewBox="0 0 16 16" {...props}>
            <path
                fill={filled ? activeColor : "none"}
                stroke={filled ? activeColor : "currentColor"}
                strokeWidth={1}
                d="M4.5 2C3.68 2 3 2.68 3 3.5v10.98l5-3.66 5 3.66V3.5c0-.82-.68-1.5-1.5-1.5H4.5Z"
            />
        </SvgIcon>
    )
});

export default FavouriteIcon
